import { Box, Select, MenuItem, makeStyles } from "@material-ui/core"
import NCText from "../NCText"
import { clsx } from "clsx"
import withContext from "../../components/DrawerConsumer"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles(() => ({
  select: {
    fontSize: "inherit",
    marginLeft: 4,
    minWidth: 65,
    height: 28,
    border: "1px solid #CED4DA",
    borderRadius: 4,
    paddingRight: 4,
    "& .MuiSelect-root": {
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 6,
      paddingRight: "24px !important",
    },
    "& .MuiSelect-icon": {
      top: "calc(50% - 10px)",
      right: 2,
    },
    "&:hover": {
      borderColor: "#9E9E9E",
    },
  },
}))

const Footer = ({
  onPrev,
  onNext,
  gotoPage,
  pageCount,
  pageSize,
  setPageSize,
  currentPage,
  overrideFooterCss,
  inlineFooter
}) => {
  const { t } = useTranslation();
  const cls = useStyles();
  
  // Generate pagination buttons dynamically
  const getPaginationButtons = () => {
    const maxVisible = 5; // Show 5 page buttons
    const buttons = [];
    let startPage = 1;
    let endPage = pageCount;

    if (pageCount > maxVisible) {
      const halfWindow = Math.floor(maxVisible / 2);
      startPage = Math.max(1, currentPage - halfWindow);
      endPage = Math.min(pageCount, startPage + maxVisible - 1);
      
      // Adjust startPage if we're near the end
      if (endPage - startPage < maxVisible - 1) {
        startPage = Math.max(1, endPage - maxVisible + 1);
      }
    }

    // Show first page if not in range
    if (startPage > 1) {
      buttons.push(
        <button
          key={1}
          className={clsx({ active: currentPage === 1 })}
          onClick={() => gotoPage(1)}
        >
          1
        </button>
      );
      if (startPage > 2) {
        buttons.push(<span key="dots-start">...</span>);
      }
    }

    // Show page range
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          className={clsx({ active: currentPage === i })}
          onClick={() => gotoPage(i)}
        >
          {i}
        </button>
      );
    }

    // Show last page if not in range
    if (endPage < pageCount) {
      if (endPage < pageCount - 1) {
        buttons.push(<span key="dots-end">...</span>);
      }
      buttons.push(
        <button
          key={pageCount}
          className={clsx({ active: currentPage === pageCount })}
          onClick={() => gotoPage(pageCount)}
        >
          {pageCount}
        </button>
      );
    }

    return buttons;
  };

  const getFooter = () => (
    <div className="table-footer">
      <NCText variant="body2">
        {t("no_of_rows")}:&nbsp;
        <Select
          value={pageSize}
          onChange={e => {
            setPageSize(e.target.value || undefined)
            gotoPage(1)
          }}
          disableUnderline
          className={cls.select}
          MenuProps={{ style: { marginTop: 4 } }}
        >
          {[2, 5, 10, 20].map((option, i) => (
            <MenuItem key={i} value={option} dense style={{ fontSize: "0.875rem" }}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </NCText>
      <div>
        <button className="" onClick={onPrev} disabled={currentPage === 1}>
          {t("prev")}
        </button>
        {getPaginationButtons()}
        <button className="" onClick={onNext} disabled={currentPage === pageCount}>
          {t("next")}
        </button>
      </div>
    </div>
  )
  return inlineFooter ? (
    getFooter()
  ) : (
    <Box
      p={"10px"}
      position={"fixed"}
      bottom={0}
      // width={props.drawer ? "79.5%" : "92.5%"}
      width={"-webkit-fill-available"}
      bgcolor={"#F3FAFC"}
      m={"20px 0 0 -30px"}
      
      style={overrideFooterCss ? overrideFooterCss : {}}
    >
      {getFooter()}
    </Box>
  )
}

export default withContext(Footer)

